import React from 'react';
import TierIcon from '@wix/da-ds/pkg/Icons/Tier';
import { useTranslation } from 'react-i18next';
import DeviationDumbView from '../../../../DeviationViews/Dumbo';
import StatisticsBar from '../../../../DeviationViews/Helper/StatisticsBar';
import s from './TierCardForExplorer.scss';
const COVER_IMAGE_RATIO = 1.774;
const coverImagePadding = parseInt(s['padding']);
const TierCardForExplorer = ({ deviation , width , onClick  })=>{
    const { t  } = useTranslation();
    const { title , coverImage , tier  } = deviation;
    if (!deviation.tier) {
        return null;
    }
    const onClickHandler = ()=>onClick(deviation);
    const coverImageWidth = width - 2 * coverImagePadding;
    const coverImageHeight = width / COVER_IMAGE_RATIO;
    const { stats: { subscribers: numSubscribers = undefined  } = {}  } = tier || {};
    const stats = [
        numSubscribers !== undefined && {
            icon: TierIcon,
            label: t('deviationview.tierCard.subscribers', {
                count: numSubscribers
            })
        }
    ].filter((stat)=>stat);
    return /*#__PURE__*/ React.createElement("div", {
        className: s['root'],
        onClick: onClickHandler
    }, /*#__PURE__*/ React.createElement("div", {
        className: s['dumbo-wrapper']
    }, coverImage ? /*#__PURE__*/ React.createElement(DeviationDumbView, {
        className: s['dumbo'],
        deviation: coverImage,
        width: coverImageWidth,
        height: coverImageHeight
    }) : /*#__PURE__*/ React.createElement("div", {
        className: s['placeholder-cover'],
        style: {
            width: coverImageWidth,
            height: coverImageHeight
        }
    })), /*#__PURE__*/ React.createElement("div", {
        className: s['title']
    }, title), !!stats.length && /*#__PURE__*/ React.createElement(StatisticsBar, {
        className: s['stats'],
        stats: stats
    }));
};
TierCardForExplorer.displayName = 'TierCardForExplorer';
export default TierCardForExplorer;
